module.exports = __webpack_public_path__ + "img/questions-mid-bubble.bfb58c1d.svg";